import {
  REGISTER_ASSET_TYPES,
  REGISTER_ASSET_TYPE_SYNONYMS_MAP,
} from '@modules/consolidator/constants/register-asset/types'

export const normalizeAssetTypeText = (textValue) =>
  String(textValue || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replaceAll(/[\u0300-\u036f]/g, '')

export const resolveAssetType = (assetType) => {
  if (!assetType) return ''
  const trimmedType = String(assetType).trim()
  const directMatch = Object.values(REGISTER_ASSET_TYPES).find(
    (registeredType) => registeredType === trimmedType
  )
  if (directMatch) return directMatch
  const normalizedType = normalizeAssetTypeText(trimmedType)
  return REGISTER_ASSET_TYPE_SYNONYMS_MAP[normalizedType] || ''
}

export const isAssetTypeMatch = (assetType, targetType) =>
  resolveAssetType(assetType) === targetType

export const isFundType = (assetType) =>
  isAssetTypeMatch(assetType, REGISTER_ASSET_TYPES.FUNDOS)
